import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class GooglePlacesService {

    constructor() { }

    public defaultOptions: any =
    {
        types: ['address'],
        fields: ['address_components'],
        componentRestrictions: { country: 'AU' }
      };


    public toAddress(googleAddr: any): any {
        let components = googleAddr.address_components;
        let subpremise = _.find(components, (c: any) => { return _.find(c.types, (n: string) => n == 'subpremise'); });
        let number = _.find(components, (c: any) => { return _.find(c.types, (n: string) => n == 'street_number'); });
        let route = _.find(components, (c: any) => { return _.find(c.types, (n: string) => n == 'route'); });
        let suburb = _.find(components, (c: any) => { return _.find(c.types, (n: string) => n == 'locality'); });
        let state = _.find(components, (c: any) => { return _.find(c.types, (n: string) => n == 'administrative_area_level_1'); });
        let postCode = _.find(components, (c: any) => { return _.find(c.types, (n: string) => n == 'postal_code'); });

        let numberName = number.long_name;
        
        if(subpremise && number)
        {
            numberName = subpremise.long_name + '/' + number.long_name;
        }

        let streetName =  route.long_name;
        if(numberName)
        {
            streetName = numberName + ' ' + streetName;
            streetName = streetName.trim();
        }
        

        let address = {
            address1: streetName,
            address2: null,
            suburb: suburb.short_name,
            state: state.short_name,
            postCode: postCode.short_name
        };

        return address;
    }

}
